import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ChevronLeft } from "lucide-react";

const TITLES = {
    "termos": "Termos & Condições",
    "privacidade": "Política de Privacidade",
    "devolucoes": "Política de Devoluções",
};

const FIELDS = {
    "termos": "legal_terms",
    "privacidade": "legal_privacy",
    "devolucoes": "legal_returns",
};

export default function LegalPage() {
    const { slug } = useParams();
    const [text, setText] = useState("");
    useEffect(() => {
        api.get("/settings").then((r) => {
            const f = FIELDS[slug];
            setText(r.data?.[f] || "Conteúdo não disponível.");
        });
    }, [slug]);
    return (
        <div className="container-edge py-16 max-w-3xl" data-testid="legal-page">
            <Link to="/" className="btn-ghost text-xs">
                <ChevronLeft size={14} /> Início
            </Link>
            <div className="label-mono text-magenta mt-4">Informação legal</div>
            <h1 className="font-display font-black text-4xl tracking-tighter mt-2 mb-8">
                {TITLES[slug] || "Documento legal"}
            </h1>
            <div className="border-2 border-ink bg-white p-8 prose max-w-none whitespace-pre-line">
                {text}
            </div>
        </div>
    );
}
